import * as React from 'react';
import {
  Logging,
} from '@vcd-ecm-ui/Common';
import { VtxButton, VtxIcon } from '@vertexinc/vtx-ui-react-component-library';
import FooterProps from './FooterProps.interface';
import '../common-settings.scss';

const Footer = ({
  onCancel,
  cancelVisible = true,
  cancelEnabled = true,
  onSave,
  saveVisible = true,
  saveEnabled = true,
}: FooterProps): JSX.Element => {
  Logging.Debug('Footer');

  const Spacer = () => <span style={{ marginRight: '10px' }} />;

  return (
    <>
      <div className="certificateSettingsFooter">
        {
          saveVisible
          && (
            <VtxButton
              id="saveButton"
              disabled={!saveEnabled}
              onClick={onSave}
              type="primary"
            >
              Save
            </VtxButton>
          )
        }
        <Spacer />
        {
          cancelVisible
          && (
            <VtxButton
              id="cancelButton"
              disabled={!cancelEnabled}
              onClick={onCancel}
              type="default"
            >
              Cancel
            </VtxButton>
          )
        }
      </div>
    </>
  );
};

export default Footer;
